// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2021-04-27 11:28:26 +0200 (Tue, 27 Apr 2021) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 118782 $
//  Purpose   : user management
// =============================================================================

//~ export {sagas} from './sagas'

//~ import * as reducers from './reducers'
//~ export {reducers}

//~ import * as actions from './actions'
//~ export {actions}

import * as views from './views'
export {views}

export const parts = true
